import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { AvailabilityComponent } from './availability/availability.component'
import { EquipmentAnalyticsComponent } from './equipment-analytics/equipment-analytics.component'
import { EquipmentCostRevenueComponent } from './equipment-reports/equipment-cost-revenue.component'
import { EquipmentReportComponent } from './equipment-reports/equipment-report.component'
import { EquipmentWarrantyComponent } from './equipment-reports/equipment-warranty.component'
import { EquipmentWorkOrdersComponent } from './equipment-reports/equipment-work-orders.component'
import { FuelAnalyticsComponent } from './fuel-analytics/fuel-analytics.component'
import { FuelEntryComponent } from './fuel-entry/fuel-entry.component'
import { FuelRecordsComponent } from './fuel-records/fuel-records.component'
import { LifetimeMeterEntryComponent } from './lifetime-meter-entry/lifetime-meter-entry.component'
import { QrCodesComponent } from './qr-codes/qr-codes.component'
import { SchedulingComponent } from './scheduling/scheduling.component'
import { SubCategoryPriorityComponent } from './sub-category-priority/sub-category-priority.component'
import { PartsFluidsComponent } from './parts-fluids/parts-fluids.component'
import { PartsFluidsLookupComponent } from './parts-fluids-lookup/parts-fluids-lookup.component'
import { PurchasedMaterialsComponent } from './purchased-materials/purchased-materials.component'
import { TireManagementComponent } from './tire-management/tire-management.component'
import { WorkOrderQueueComponent } from './work-order-queue/work-order-queue.component'

export const equipmentRoutes: Routes = [
    {
        path: 'equipment',
        children: [
            RouteUtil.Make('fuel-entry', FuelEntryComponent, FeatureType.EquipmentFuelEntryEdit),
            RouteUtil.Make('fuel-records', FuelRecordsComponent, FeatureType.EquipmentFuelRecordsView),
            RouteUtil.Make('fuel-analytics', FuelAnalyticsComponent, FeatureType.EquipmentFuelRecordsView),
            RouteUtil.Make('qr-codes', QrCodesComponent, FeatureType.EquipmentFuelRecordsView),
            RouteUtil.Make('availability', AvailabilityComponent, FeatureType.EquipmentAvailabilityView),
            RouteUtil.Make('scheduling', SchedulingComponent, FeatureType.EquipmentAvailabilityView),
            RouteUtil.Make('work-order-queue', WorkOrderQueueComponent, FeatureType.EquipmentWorkOrdersView),
            RouteUtil.Make('equipment-analytics', EquipmentAnalyticsComponent, FeatureType.EquipmentAvailabilityView),
            RouteUtil.Make('lifetime-meter-entry', LifetimeMeterEntryComponent, FeatureType.EquipmentFuelRecordsEdit),
            RouteUtil.Make('equipment-report', EquipmentReportComponent, FeatureType.EquipmentReportView),
            RouteUtil.Make('equipment-cost-revenue', EquipmentCostRevenueComponent, FeatureType.EquipmentReportView),
            RouteUtil.Make('equipment-warranty', EquipmentWarrantyComponent, FeatureType.EquipmentReportView),
            RouteUtil.Make('equipment-work-orders', EquipmentWorkOrdersComponent, FeatureType.EquipmentReportView),
            RouteUtil.Make('sub-category-priority', SubCategoryPriorityComponent, FeatureType.EquipmentSubCategoryPriorityView),
            RouteUtil.Make('tire-management', TireManagementComponent, FeatureType.EquipmentTireManagementView),
            RouteUtil.Make('parts-fluids', PartsFluidsComponent, FeatureType.EquipmentPartsFluidsView),
            RouteUtil.Make('parts-fluids-lookup', PartsFluidsLookupComponent, FeatureType.EquipmentPartsFluidsView),
            RouteUtil.Make('purchased-materials', PurchasedMaterialsComponent, FeatureType.PurchasingMaterialsView),
        ],
    },
]
